import { GlobalService } from 'src/app/global.service';
import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode, MatDialog } from '@angular/material';
import { PdfPreviewComponent } from 'src/app/pdf-preview/pdf-preview.component';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-milk-acknowlegdement-report-per-session',
  templateUrl: './milk-acknowlegdement-report-per-session.component.html',
  styleUrls: ['./milk-acknowlegdement-report-per-session.component.scss']
})
export class MilkAcknowlegdementReportPerSessionComponent implements OnInit {
  sessions: any;
  selected_date: any;
  selected_session_id: any;
  is_document_available: boolean = true;
  document_file: any = null;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  pdf_data: any;
  title: any;

  constructor(private httpService: HttpService, private dialog: MatDialog, private domSanitizer: DomSanitizer, private global: GlobalService) {
    this.title = this.global._active_display_name;
    this.httpService.getSession().subscribe((sessions: []) => {
      console.log(sessions);
      this.sessions = sessions;
    }, (error) => {
      console.log(error);
    });
  }

  getClicked() {
    let data_dict = {
      'selected_date': this.selected_date,
      'selected_session_id': this.selected_session_id
    };
    console.log(data_dict);
    this.is_document_available = false;
    this.httpService.serveMilkAcknowledgementReport(data_dict).subscribe((data) => {
      console.log(data);
      this.document_file = data;
      this.pdf_data = this.domSanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + data['pdf']);
      this.is_document_available = true;
    }, (error) => {
      this.is_document_available = true;
    });
  }

  getPdf() {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(this.pdf_data);
  }

  downloadClicked() {
    const linkSource = 'data:application/pdf;base64,' + this.document_file['pdf'];
    const downloadLink = document.createElement("a");
    const fileName = this.document_file['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
    // const dialogRef = this.dialog.open(PdfPreviewComponent, {
    //   height: '700px',
    //   width: '700px',
    //   data: {
    //     'pdf': linkSource,
    //     'fileName': fileName
    //   },
    // });
    // dialogRef.afterClosed().subscribe(result => {
    // });
  }

  changeEvent() {
    this.document_file = null;
  }
  
  ngOnInit() {
  }


}
